  /*============Contact Form Controller
  ================================*/
  angular
      .module('vppApp')
      .controller('contactFormController', contactFormController);

  contactFormController.$inject = ['$scope', '$http', '$state', 'apiFactory', '$stateParams', 'vppConfig', 'AuthenticationService'];

    function contactFormController($scope, $http, $state, apiFactory, $stateParams, vppConfig, AuthenticationService){
      // console.log('contactFormController()');

      switch (domainAbbr) {
        case 'gmed':
            $scope.phoneNumber = vppConfig.phoneNumbers.gmed;
            $scope.siteName = vppConfig.contactUsNames.gmed;
            break;
        case "mpp":
            $scope.phoneNumber = vppConfig.phoneNumbers.mpp;
            $scope.siteName = vppConfig.contactUsNames.mpp;
            break;
        case "cgp":
            $scope.phoneNumber = vppConfig.phoneNumbers.cgp;
            $scope.siteName = vppConfig.contactUsNames.cgp;
            break;
        case "ded":
            $scope.phoneNumber = vppConfig.phoneNumbers.ded;
            $scope.siteName = vppConfig.contactUsNames.ded;
            break;
        case "emp": 
            $scope.phoneNumber = vppConfig.phoneNumbers.emp;
            $scope.siteName = vppConfig.contactUsNames.emp;
            break;
        case "sup":
            $scope.phoneNumber = vppConfig.phoneNumbers.sup;
            $scope.siteName = vppConfig.contactUsNames.sup;
            break;
        case "frd":
            $scope.phoneNumber = vppConfig.phoneNumbers.frd;
            $scope.siteName = vppConfig.contactUsNames.frd;
            break;
        default:
            $scope.phoneNumber = null;
    }

      $scope.isAuthenticated = AuthenticationService.isAuthenticated();

      $scope.subjectOptions = [
        { text: 'Content not loaded' }
      ];
      if (AuthenticationService.isAuthenticated()) {
        var accountId = AuthenticationService.getAuthenticatedID();
        $scope.accountInfo = {
          "accountDetails": {
            "firstName": "",
            "lastName": "",
            "streetAddress": "",
            "city": "",
            "stateInclPR": "",
            "postalCode": "",
            "phoneNumber": "",
            "emailAddress": "",
            "cellPhone": ""
          }
        };
        // get profile details:
        apiFactory.getProfileDetails(accountId).then(function (response) {
          $scope.accountInfo.accountDetails = response.data.customerDetails;

          $scope.firstName = $scope.accountInfo.accountDetails.firstName;
          $scope.lastName = $scope.accountInfo.accountDetails.lastName;
          $scope.address1 = $scope.accountInfo.accountDetails.streetAddress;
          $scope.city = $scope.accountInfo.accountDetails.city;
          $scope.zip = $scope.accountInfo.accountDetails.postalCode;
          $scope.email = $scope.accountInfo.accountDetails.emailAddress;
          $scope.homePhone = $scope.accountInfo.accountDetails.phoneNumber;
          $scope.state = $scope.accountInfo.accountDetails.stateInclPR;
          if ($scope.accountInfo.accountDetails.stateInclPR == undefined) {
            $scope.state = $scope.accountInfo.accountDetails.state;
          }

        }, function errorCallback(response) {
          // $log.info(response.data.errors);
          $scope.serverError = response.data.errors;
          TimeOutService.checkAuthError(response);
          // called asynchronously if an error occurs
          // or server returns response with an error status.
          console.log('errorCode: ' + $scope.serverError);
        });
      }



      var apiSite = vppConfig.folderPath;

      // Get the JSON file for the subject options drop down
      $http.get('./content/json/misc/' + apiSite + '/contact-form-subjects.json')
          .then(function successCallback(response) {
            // console.log('getSubjectOptions() success', response.data);
            $scope.subjectOptions = response.data.content.subjects;

          }, function errorCallback(response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            console.log('getSubjectOptions() error', response);
          });


      $scope.submit = function() {
        console.log('submit()');
        $scope.responsePending = true;

        var sendData = {
          subject: $scope.subject,
          firstName: $scope.firstName,
          lastName: $scope.lastName,
          addressLine1: $scope.address1,
          addressLine2: $scope.address2 || 'undefined',
          city: $scope.city,
          state: $scope.state,
          zipCode: $scope.zip,
          phoneNumber: $scope.homePhone,
          email: $scope.email,
          workPhone: $scope.workPhone || '5555555555',
          message: $scope.message
        };

        console.log('data', sendData);

        apiFactory.contactForm(sendData)
            .then(function successSignOut(response) {
              $state.go("contact-success");
              // this callback will be called asynchronously
              // when the response is available
            }, function errorCallback(response) {
              console.log(response.data.errors);
              $scope.responsePending = false;
              $scope.serverError = response.data.errors;
              // called asynchronously if an error occurs
              // or server returns response with an error status.
            });
      };
  };